@file:Suppress("DEPRECATION")

package app.alefly.challenge

import app.alefly.domain.model.Challenge
import app.alefly.domain.model.ChallengeResult
import kotlinx.datetime.Instant
import kotlin.time.Clock as KotlinClock

object ChallengePolicy {
    fun isExpired(
        challenge: Challenge,
        now: Instant = Instant.fromEpochMilliseconds(KotlinClock.System.now().toEpochMilliseconds()),
    ): Boolean = now >= challenge.expiresAt

    fun sortResults(results: List<ChallengeResult>): List<ChallengeResult> = results.sortedWith(
        compareByDescending<ChallengeResult> { it.score }
            .thenBy { it.hintsUsedCount }
            .thenBy { it.durationMs }
            .thenBy { it.submittedAt }
    )
}
